// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__msCPk","newExpiryDate":"styles_newExpiryDate__1WAYm","footer":"styles_footer__1hp6m"};